// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as PricingDashboardConfig from "../library/utils/PricingDashboardConfig.bs.js";
import * as CurrencyMajorMinorMapper from "../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function getVm(free_kms, slabs) {
  return List.mapi((function (index, slab) {
                return {
                        slab_no: index === (List.length(slabs) - 1 | 0) ? String(index + 1 | 0) + "(Last)" : String(index + 1 | 0),
                        slab_range: slab.slab_km === PricingDashboardConfig.last_slab_upper_limit ? ">" + String(index === 0 ? free_kms : List.nth(slabs, index - 1 | 0).slab_km) : String(index === 0 ? free_kms : List.nth(slabs, index - 1 | 0).slab_km) + (" - " + String(slab.slab_km)),
                        slab_km: slab.slab_km,
                        price_per_km: CurrencyMajorMinorMapper.baseToCurrency(slab.price_per_km),
                        price_per_min: CurrencyMajorMinorMapper.baseToCurrency(slab.price_per_min),
                        is_last: index === (List.length(slabs) - 1 | 0)
                      };
              }), slabs);
}

export {
  getVm ,
  
}
/* No side effect */
